// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import RatingLarge from '../../../common/components/RatingLarge/RatingLarge';

function ReviewFeedbackBlock(props) {
  const { averageRating, reviews } = props;
  return (
    <>
      <RatingLarge
        averageRating={averageRating}
        reviewsCount={reviews.length}
        profileReviews="true"
        textAlign="left"
      />
    </>
  );
}

ReviewFeedbackBlock.propTypes = {
  averageRating: PropTypes.number,
  reviews: PropTypes.array,
};

export default ReviewFeedbackBlock;
